<dx-data-grid
    bds-grid
    id="bdsReportGrid"
    [dataSource]="gridSource"
    height="80vh"
    minHeight="200px"
    [allowColumnResizing]="false"
    dataRowTemplate="dataRowTemplateName"
    (onContentReady)="onContentReady($event)"
>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxi-column
        dataField="car_init"
        caption="Car Init."
        sortOrder="asc"
        [sortIndex]="0"
    ></dxi-column>
    <dxi-column dataField="car_no" caption="Car No." sortOrder="asc" [sortIndex]="1"></dxi-column>
    <dxi-column
        dataField="ship_date_time"
        dataType="date"
        [format]="{ type: 'shortDate' }"
        caption="Ship Date"
    ></dxi-column>
    <dxi-column dataField="cust_no" caption="Consignee No."></dxi-column>
    <dxi-column dataField="cust_name" caption="Consignee Name"></dxi-column>
    <dxi-column dataField="comm_code" caption="CommCode"></dxi-column>
    <dxi-column dataField="loc_city" caption="Location City"></dxi-column>
    <dxi-column dataField="loc_state" caption="Location State"></dxi-column>
    <dxi-column dataField="road" caption="Road"></dxi-column>
    <ng-container *dxTemplate="let item of 'dataRowTemplateName'">
        <tr class="main-row">
            <td>{{ item.data.car_init }}</td>
            <td>{{ item.data.car_no }}</td>
            <td>{{ item.data.ship_date_time | date : 'MM/dd/yyyy' }}</td>
            <td>{{ item.data.cust_no }}</td>
            <td>{{ item.data.cust_name }}</td>
            <td>{{ item.data.comm_code }}</td>
            <td>{{ item.data.loc_city }}</td>
            <td>{{ item.data.loc_state }}</td>
            <td>{{ item.data.road }}</td>
        </tr>
        <tr class="second-row">
            <td></td>
            <td colspan="2">
                <div>
                    <span><b>Comments: </b></span>{{ item.data.comment_date | date : 'MM/dd/yyyy' }}
                </div>
            </td>
            <td colspan="7">{{ item.data.comments }}</td>
        </tr>
        <tr>
            <td>{{ item.data.comment_type }}</td>
            <td>{{ item.data.comment_code }}</td>
        </tr>
    </ng-container>
</dx-data-grid>
<div style="text-align: right; padding: 10px; font-weight: bold">Total Count: {{ totalCount }}</div>
